import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { TemplateSourceComponent } from '../../../../../pages/media/template-source/template-source.component';
import { TemplateSourceEditComponent } from '../../../../../pages/media/template-source/template-source-edit/template-source-edit.component';
import { templateSourceEntries } from './templateSourceEntries';

export const templateSources: Route = {
  path: 'template-sources',
  title: 'nav.templateSources',
  data: {
    icon: SbIcons.template,
    breadcrumb: 'nav.templateSources',
    id: RoutingID.templateSources,
  },

  children: [
    {
      path: '',
      component: TemplateSourceComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'template-sources-edit/:templateSourceID',
      title: 'nav.templateGroup.details',
      data: {
        breadcrumb: 'nav.templateGroup.details',
        icon: SbIcons.edit,
        id: RoutingID.templateSourceEdit,
      },
      children: [
        {
          path: '',
          component: TemplateSourceEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'template-sources-create',
      title: 'nav.templateSources.create',
      data: {
        breadcrumb: 'nav.templateSources.create',
        icon: SbIcons.plus,
        id: RoutingID.templateSourceCreate,
      },
      children: [
        {
          path: '',
          component: TemplateSourceEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    templateSourceEntries,
  ],
};
